// extracted by mini-css-extract-plugin
export default {"teethMovement_table":"teethMovement_table___SV_pV"};